import { Controller } from "@hotwired/stimulus"

// Reveals a follow-up question only while a choice carrying the `when` value
// is checked. Works for a radio group and for a single checkbox alike.
export default class extends Controller {
  static targets = ["choice", "fields"]
  static values = { when: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const chosen = this.choiceTargets.some((choice) => choice.checked && choice.value === this.whenValue)

    this.fieldsTarget.classList.toggle("hidden", !chosen)

    // Hiding alone is not enough — hidden inputs still serialize, which would
    // post an answer to a question that is no longer being asked.
    this.fieldsTarget.querySelectorAll("input, textarea, select").forEach((field) => {
      field.disabled = !chosen
    })
  }
}
